export const getFilteredListOfOptionValues = (values, dependencyValue) => {
    return values.filter(({ parentOptionValue }) => {
        return parentOptionValue === dependencyValue;
    });
};
